<div class="anc-stat-tile" [ngClass]="'anc-stat-tile--' + variant()">
    <div class="anc-stat-tile__label" translate>{{ label() }}</div>
    <div class="anc-stat-tile__value">{{ value() }}</div>
</div>
